<template>
    <div class="m-viewport">
        <div class="u-nav" v-pin>
            <div class="wrapper">
                <div class="nav-item nav-trriger u-btn nav-1" :class="{'act' : active==0}" @click="scrollTo(0)"></div>
                <div class="nav-item nav-trriger u-btn nav-2" :class="{'act' : active==1}" @click="scrollTo(1)"></div>
                <div class="nav-item nav-trriger u-btn nav-3" :class="{'act' : active==2}" @click="scrollTo(2)"></div>
                <div class="nav-item nav-trriger u-btn nav-4" :class="{'act' : active==3}" @click="scrollTo(3)"></div>
                <div class="nav-item nav-trriger u-btn nav-5"><a href="http://www.m3guo.com/v2/news/report/1637134975.html?v=1" target="_blank" rel="noopener noreferrer"></a></div>
            </div>
        </div>
        <div class="wrapper">

            <div class="body-item">
                <div class="match-info"></div>

                <div class="m-timeline">
                    <ul>
                        <li v-for="(item,index) in timeline_data" :key="index">
                            <div class="item-detail">
                                <div class="time">{{ item.title }}</div>
                                <div class="detail">{{ item.content }}</div>   
                            </div>                         
                        </li>
                    </ul>
                </div>
            </div>

            <div class="m-match-detail">
                <div class="match-item body-item">
                    <div class="title t-1"></div>
                    <div class="m-reward">
                        <reward-info></reward-info>
                    </div>
                </div>
                <div class="match-item body-item">
                    <div class="title t-2"></div>
                    <div class="m-media">
                        <media-view></media-view>
                    </div>
                </div>
                <div class="match-item body-item">
                    <div class="title t-3"></div>
                    <div class="m-schedules">
                        <schedule-info></schedule-info>
                    </div>
                </div>
                <div class="match-item">
                    <div class="title t-4"></div>
                    <m-qa></m-qa>
                </div>                
            </div>
        </div>
    </div>  
</template>

<style scoped>
.m-viewport{
    min-width: 1194px;
}

.m-viewport>.wrapper {
    width: 1194px;
    padding-top: 95px;
    margin: 0 auto;
}

.u-nav {
    width: 100%;
    left: 50%;
    height: 82px;
    margin: 0 auto;
    background-image: url(../assets/images/bg-nav.png);
    background-position: center top;
    z-index: 100;
}

.u-nav .wrapper {
    display: flex;
    width: 1194px;
    margin: 0 auto;
    font-size: 0;
    color: transparent;
}

.nav-item {
    position: relative;
    width: 20%;
    height: 82px;
    background-position: center center;
    background-repeat: no-repeat;
}

.nav-item a{
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    z-index: 5;
}

.nav-item::after{
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 49px;
    background-image: url(../assets/images/bg-now.png);
    background-position: center center;
    background-repeat: no-repeat;
    opacity: 0;
    transition: .3s all ease-in;
    pointer-events: none;  
}

.nav-item.act::after,
.nav-item:hover::after{
    opacity: 1;
}

.nav-item.nav-1{
    background-image: url(../assets/images/nav-1.png);
}

.nav-item.nav-2{
    background-image: url(../assets/images/nav-2.png);
}

.nav-item.nav-3{
    background-image: url(../assets/images/nav-3.png);
}

.nav-item.nav-4{
    background-image: url(../assets/images/nav-4.png);
}

.nav-item.nav-5{
    background-image: url(../assets/images/nav-5.png);
}

.match-info{
    width: 1194px;
    height: 450px;
    margin: 0 auto;
    background-image: url(../assets/images/bg-match-info.png);
}

.m-timeline {
    width: 1187px;
    padding-top: 82px;
    margin-top: 64px;
    background-image: url(../assets/images/bg-timeline.png);
    background-repeat: no-repeat;
    font-family:"楷体","楷体_GB2312","Microsoft Yahei";
}

.m-timeline ul{
    width: 100%;
    display: flex;
}

.m-timeline li{
    width: 20%;
    font-size: 20px;
    vertical-align: top;
}

.m-timeline .item-detail{
    padding: 10px 14px 0 12px;
}

.m-timeline li .time{
    margin-bottom: 10px;
    text-align: center;
    color: #feef8d;
}

.m-timeline li .detail{
    padding: 0 10px 0 15px;
    color: #a7965d;
}

.match-item>.title {
    width: 685px;
    height: 280px;
    margin: 0 auto 25px;
    background-position: center;
    background-repeat: no-repeat;
}

.match-item>.title.t-4{
    height: 200px;
}

.m-reward{
    height: 1275px;
}

.m-media{
    height: 750px;
}

.m-schedules{
    height: 580px;
}
</style>

<script>
import QA from '@/components/qa.vue'
import rewardInfo from '@/components/rewardTab.vue'
import media from '@/components/media.vue'
import scheduleInfo from '@/components/scheduleTab.vue'


export default({
    data() {
      return {
          timeline_data : [
              {
                  'title' : '11月17日-11月25日',
                  'content' : '队长创建战队后将战队码告知参赛队员，队员上线确认填写个人信息。'
              },              {
                  'title' : '11月26日—11月27日',
                  'content' : '出征巅峰对决赛、装备大师赛赛程对阵安排公布。'
              },              {
                  'title' : '11月29日—12月8日',
                  'content' : '全服同战，装备大师赛对决。'
              },              {
                  'title' : '12月9日—12月19日',
                  'content' : '神兵值前32名战队激情较量，竞逐星赛季全国决赛四强名额。'
              },              {
                  'title' : '时间待定',
                  'content' : '四强巅峰对决，争夺2021军团出征全服争霸赛总冠军。'
              },
          ],
          active : 0,
          item_top_data : [],
      }  
    },
    mounted (){
        this.collect_top_data();
        this.$nextTick(function () {
            window.addEventListener('scroll', this.handleScroll)
        })        
    },
    components : {
        'm-qa' : QA,
        'reward-info': rewardInfo,
        'media-view' : media,
        'reward-info': rewardInfo,
        'schedule-info' : scheduleInfo,
    },
    methods : {
        handleScroll () {
            var self = this;
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop//获取滚动距离
            this.scrollTop = scrollTop//data里return了一个全局的scrollTop

            var result = collectActiveNav();
            this.active = result[0];

            function collectActiveNav(){
                var ret = [] ;

                let body_item = document.querySelectorAll('.body-item');

                for (var i = 0; i < body_item.length; i++) {
                    let ele = body_item[i];
                    if (inViewport(i,0,ele)){
                        ret.push(i);
                    }                    
                } 
                return ret;
            };

            function inViewport(i, delta,ele){
                var top = self.item_top_data[i],
                    scrollTop = self.scrollTop;
                
                delta = delta || 100;
                
                //return top + delta > scrollTop && top - delta < scrollTop + document.documentElement.clientHeight;
                return top - delta + ele.offsetHeight > scrollTop && top - delta < scrollTop + document.documentElement.clientHeight;
            };	         
        },
        collect_top_data (){
            let body_item = document.querySelectorAll('.body-item');

            for (var i = 0; i < body_item.length; i++) {
                this.item_top_data.push(body_item[i].offsetTop);
            }
            
        },
        scrollTo(index){
            // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉
            const STEP = 50
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop//获取滚动距离
            var targetOffsetTop = this.item_top_data[index];

            if (scrollTop < targetOffsetTop) {
                // 往下滑
                smoothDown()
            }else{
                smoothUp()
            }
            // 定义下滑函数
            function smoothDown() {
                // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
                if (scrollTop < targetOffsetTop) {
                    if (targetOffsetTop - scrollTop >= STEP) {
                        scrollTop += STEP
                    } else {
                        scrollTop = targetOffsetTop
                    }
                    document.body.scrollTop = scrollTop
                    document.documentElement.scrollTop = scrollTop
                    // 屏幕在绘制下一帧时会回调传给 requestAnimationFrame 的函数
                    requestAnimationFrame(smoothDown)
                }
            }
            // 定义上滑函数
            function smoothUp() {
                // 如果当前 scrollTop 大于 targetOffsetTop 说明视口已经滑过指定位置需要上滑
                if (scrollTop > targetOffsetTop) {
                    if (scrollTop - targetOffsetTop >= STEP) {
                        scrollTop -= STEP
                    } else {
                        scrollTop = targetOffsetTop
                    }
                    document.body.scrollTop = scrollTop
                    document.documentElement.scrollTop = scrollTop
                    requestAnimationFrame(smoothUp)
                }
            }
        },                        
    },
})
</script>



// WEBPACK FOOTER //
// src/components/body.vue